import { useCallback } from 'react';
import { useGetResetPasswordLinkMutation } from 'api/user-domain/user-domain';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';

const useCopyResetPasswordLink = () => {
  const [getResetPasswordLink] = useGetResetPasswordLinkMutation();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const handleCopyResetPasswordLink = useCallback(
    async emailUser => {
      try {
        const result = await getResetPasswordLink({ emailUser }).unwrap();
        if (result && typeof result === 'string' && result !== '') {
          try {
            await navigator.clipboard.writeText(result);
            enqueueSnackbar(
              t('page.customers.copyResetPasswordLink.toast.success'),
              { severity: 'success' },
            );
            return null;
          } catch {
            return result;
          }
        } else {
          throw new Error('No link returned');
        }
      } catch (error) {
        enqueueSnackbar(t('page.customers.copyResetPasswordLink.toast.error'), {
          severity: 'error',
        });
        return null;
      }
    },
    [enqueueSnackbar, getResetPasswordLink, t],
  );

  return handleCopyResetPasswordLink;
};

export default useCopyResetPasswordLink;
